import type { ReactNode } from 'react';
import { useWootric } from '@/hooks/useWootric';
import type { WootricUser } from '@/types/wootric';

interface WootricProviderProps {
  readonly children: ReactNode;
  readonly user: WootricUser | null;
  readonly enabled?: boolean;
  readonly wootricToken?: string;
  readonly cookieConsent?: Record<string, boolean> | null;
  readonly environment?: string;
}

export function WootricProvider({ children, user, enabled = true, wootricToken, cookieConsent, environment }: WootricProviderProps) {
  useWootric({ user, enabled, wootricToken, cookieConsent, environment });

  return <>{children}</>;
}
